// extracted by mini-css-extract-plugin
var _1 = "SelectControlErrorText-moduleSelectControlErrorText__vjixS";
export { _1 as "SelectControlErrorText" }
